module.exports = __webpack_public_path__ + "prod/1.42.2/img/backup.fef26875.svg";